import { checkmarkBoxIcon } from "@repo/skapa";
import { t } from "@repo/translation";

import { type SubTaskConfig } from "../settings/SettingsProvider";
import { FilterCheckbox } from "./FilterCheckbox";

interface SelectAllCheckboxGroupProps {
  parentKey: string;
  subTypes: SubTaskConfig[];
  selected: string[];
  onSelectAll: (isChecked: boolean) => void;
}

const SELECT_ALL_KEY = "selectAll";

export const SelectAllCheckboxGroup = ({
  parentKey,
  subTypes,
  selected,
  onSelectAll,
}: SelectAllCheckboxGroupProps) => {
  const isChecked = subTypes.every((subType) =>
    selected.includes(`${parentKey}_${subType.name_key}`)
  );

  return (
    <FilterCheckbox
      key={`${parentKey}-${SELECT_ALL_KEY}`}
      id={`${parentKey}-${SELECT_ALL_KEY}`}
      value={`${parentKey}-${SELECT_ALL_KEY}`}
      label={t("action.select_all")}
      checked={isChecked}
      onCheckFilter={() => onSelectAll(!isChecked)}
      icon={checkmarkBoxIcon}
    />
  );
};
